import * as React from 'react';

import { Breakpoints } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

export const Turntable = () => {
	return (
		<Svg viewBox="0 0 657 91" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden focusable="false">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M328.5 0C416.128 0 498.459 4.63731 560.436 13.037C596.513 17.9368 657 28.6113 657 45.0606C657 61.51 596.513 72.1845 560.436 77.0843C533.709 80.6717 503.176 83.6465 470.078 85.7464V85.309C470.078 85.0465 470.078 84.784 469.995 84.609C503.093 82.4216 533.544 79.5342 560.27 75.9469C621.006 67.7222 655.842 56.4352 655.842 45.0606C655.842 33.6861 621.006 22.3991 560.27 14.1744C498.377 5.77476 416.045 1.22495 328.5 1.22495C240.955 1.22495 158.623 5.77476 96.6469 14.1744C35.9943 22.4866 1.15844 33.6861 1.15844 45.0606C1.15844 56.4352 35.9943 67.7222 96.7296 75.9469C123.456 79.5342 153.907 82.5091 187.005 84.609C187.005 84.784 186.922 85.0465 186.922 85.2215V85.7464C153.824 83.559 123.291 80.6717 96.5641 77.0843C60.487 72.1845 0 61.51 0 45.0606C0 28.6113 60.487 17.9368 96.5641 13.037C158.541 4.63731 240.872 0 328.5 0ZM328.5 88.8963C371.114 88.8963 412.487 87.7589 450.881 85.7464C450.302 85.5715 449.64 85.309 448.978 85.0465C446.992 84.3465 444.758 83.559 444.758 83.384C444.758 82.8591 465.527 85.0465 465.527 85.3965C465.527 86.0964 444.013 91.7837 444.013 90.9087C444.013 90.5588 446.826 89.1588 449.143 87.9339C449.888 87.5839 450.55 87.2339 451.129 86.8839C412.652 88.9838 371.197 90.1213 328.583 90.1213C285.886 90.1213 244.513 88.9838 206.037 86.8839C206.616 87.1464 207.278 87.5839 208.105 87.9339C210.422 89.1588 213.235 90.5588 213.235 90.9087C213.235 91.6962 191.722 86.0964 191.722 85.3965C191.722 85.0465 212.491 82.8591 212.491 83.384C212.491 83.559 210.257 84.3465 208.271 85.0465C207.609 85.309 206.947 85.484 206.45 85.659C244.761 87.8464 285.969 88.8963 328.5 88.8963Z"
				fill="url(#rotation-onboarding-turntable)"
			/>
			<defs>
				<linearGradient
					id="rotation-onboarding-turntable"
					x1="328.5"
					y1="25.6415"
					x2="328.5"
					y2="73.9863"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#1B2236" stopOpacity="0" />
					<stop offset="1" stopColor="white" />
				</linearGradient>
			</defs>
		</Svg>
	);
};

const Svg = styled.svg`
	position: absolute;
	top: 50%;
	left: 50%;
	width: 50%;
	height: auto;
	transform: translate(-50%, -50%);

	@media (max-width: ${Breakpoints.b560 - 1}px) {
		width: 60%;
		top: calc(51% + 8px);
	}
`;
